var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('draggable',{ref:"draggable",attrs:{"step":_vm.step,"position":_vm.widgetsPosition,"index":_vm.index,"z-index":-1},on:{"blur":_vm.handleChange}},[_c(_vm.type,{key:_vm.index,tag:"component",attrs:{"comp-index":_vm.index,"value":_vm.value,"widgetValueChanged":_vm.widgetValueChanged,"option":_vm.options},on:{"change":_vm.timeChange}})],1),(_vm.batchFlag)?_c('div',{staticClass:"check-mask",style:({
    width: _vm.widgetsPosition.width + 'px',
    height: _vm.widgetsPosition.height + 'px',
    left: _vm.widgetsPosition.left + 'px',
    top: _vm.widgetsPosition.top + 'px',
    zIndex: -1
  })},[_c('a-checkbox',{staticClass:"checkbox",attrs:{"checked":_vm.checkValue},on:{"change":_vm.checkChange}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }